import { render } from "./Title.html?vue&type=template&id=93c258e8&scoped=true&ts=true&external"
import script from "./Title.ts?vue&type=script&lang=ts&external"
export * from "./Title.ts?vue&type=script&lang=ts&external"

import "./Title.scss?vue&type=style&index=0&id=93c258e8&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93c258e8"]])

export default __exports__